import { enforceMatchingSelections } from './matchingUtils';

const STORAGE_PREFIX = 'coust:timetable:';

function getValidSections(data, courseCode, sections) {
    if (!data[courseCode] || !Array.isArray(sections)) return [];

    const availableSections = new Set(
        (data[courseCode].sections || []).map(section => section.section)
    );

    return [...new Set(sections.filter(section => availableSections.has(section)))];
}

export function loadTimetable(term, data) {
    try {
        const stored = window.localStorage.getItem(`${STORAGE_PREFIX}${term}`);
        if (!stored) return {};

        const timetable = JSON.parse(stored);
        if (!timetable || typeof timetable !== 'object' || Array.isArray(timetable)) {
            return {};
        }

        return Object.fromEntries(
            Object.entries(timetable)
                .map(([courseCode, sections]) => {
                    const validSections = getValidSections(data, courseCode, sections);
                    return [
                        courseCode,
                        validSections.length > 0
                            ? enforceMatchingSelections(data[courseCode], validSections)
                            : validSections,
                    ];
                })
                .filter(([, sections]) => sections.length > 0)
        );
    } catch {
        return {};
    }
}

export function storeTimetable(term, timetable) {
    try {
        window.localStorage.setItem(`${STORAGE_PREFIX}${term}`, JSON.stringify(timetable));
        window.localStorage.setItem('coust:last-term', term);
    } catch {
        // Private browsing or disabled storage must not prevent planning.
    }
}

export function getStoredTerm() {
    try {
        return window.localStorage.getItem('coust:last-term');
    } catch {
        return null;
    }
}
